"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./src/pagination.module"));
__export(require("./src/pagination.pipe"));
__export(require("./src/pagination.component"));
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-bs-pagination/index.js
// module id = 315
// module chunks = 0